import { FC } from "react"
import { fmt } from "../utils/formatters"

type HBarItem = { label: string; value: number; color: string }

type HBarChartProps = {
  items: HBarItem[]
  maxValue?: number
}

export const HBarChart: FC<HBarChartProps> = ({ items, maxValue }) => {
  const mv = maxValue ?? Math.max(...items.map((i) => i.value), 1)
  return (
    <div>
      {items.map((item, i) => (
        <div className="bar-chart-row" key={i}>
          <span className="bar-chart-label" title={item.label}>
            {item.label}
          </span>
          <div className="bar-chart-track">
            <div
              className="bar-chart-fill"
              style={{
                width: `${Math.max((item.value / mv) * 100, 0)}%`,
                background: item.color,
              }}
            />
          </div>
          <span className="bar-chart-val">{fmt(item.value)}</span>
        </div>
      ))}
    </div>
  )
}
